import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Menu } from 'semantic-ui-react';
import EntryForm from '../../components/VEntry/EntryForm';
import './LoginMenu.css';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
// import { APP_DOWNLOAD_URL } from '../../utils/config';

const LoginMenu = props => {
  const { t } = useTranslation();
  const [popup, setPopup] = useState(false);
  const wrapperRef = useRef(null);
  const history = useHistory();
  const location = useLocation();
  const loggedIn = useSelector(state => state.authentication.loggedIn);


  useEffect(() => {
    document.getElementById('root').appendChild(document.getElementById('loginCover'));
    return () => {
      setPopup(false);
      document.getElementById('loginCover').style.display = 'none';
    };
  }, []);

  useEffect(() => {
    const openForm = location.hash.replace('#', '');
    if (openForm === 'login' || openForm === 'register') {
      setPopup({ show: true, form: openForm });
    }
  }, [location]);

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setPopup(false);
      }
    }
    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  const clickHandler = form => {
    history.push(`#${form}`);
    // setPopup({ show: true, form: form });
  };

  return (
    <>
      <div id="loginCover" className="loginCover" style={{ display: popup ? 'flex' : 'none' }}>
        <div className="loginRegisterBox" ref={wrapperRef}>
          <EntryForm form={popup.form} />
        </div>
      </div>
      {props.mobile ? (
        <>
          {/* Application download is temporarily hidden.
          <Menu.Item title={t("downloadApp")} as={"a"} href={APP_DOWNLOAD_URL} content={t('downloadApp')} download/>
          */}
          {loggedIn ?
            <>
              <Menu.Item title="login" onClick={() => history.push("/home")} content={t('profile')} />
            </>
            :
            <>
              {/* <Menu.Item title="login" onClick={() => clickHandler('login')} content={t('login')} /> */}
              <Menu.Item
                title="login/register"
                onClick={() => clickHandler('login')}
                content={t('register') + " / " + t('login')}
              />
            </>
          }
        </>
      ) : (
        <>
          {/* Application download is temporarily hidden.
          <Button
            as={"a"}
            href={APP_DOWNLOAD_URL}
            title={t("downloadApp")}
            className="vButton widthAuto rightSpace outlinePrimary"
            content={t("downloadApp")}
            download
          />
          */}
          {loggedIn ?
            <>
              <Button
                title={t("profile")}
                onClick={() => history.push("/home")}
                className="vButton outlinePrimary rightSpace"
                content={t("profile")}
              />
            </>
            :
            <>
              {/* <Button
                title="login"
                onClick={() => clickHandler('login')}
                className="vButton outlinePrimary rightSpace"
                content={t('login')}
              /> */}

              <Button
                title="login/register"
                primary
                onClick={() => clickHandler('login')}
                className="vButton widthAuto colorPrimary"
                content={t('register') + " / " + t('login')}
              />
            </>

          }
        </>
      )}
    </>
  );
};

export default LoginMenu;
